import PropTypes from 'prop-types';
import React from 'react';
import component from 'omniscient';

import SmartScrollView from '../../components/ScrollView/SmartScrollView';
import InternalLink from '../../components/InternalLink/InternalLink';

const definition = {
    contextTypes: {
      pathTo: PropTypes.func.isRequired,
    },
  },
  /**
   * NotFoundComponent render method
   * @return {React.Component}
   */
  render = function () {
    return (
      <main className="Layer ViewStack-layer">
        <div className="Main-wrapper is-expanded" id="main" tabIndex="-1">
          <SmartScrollView>
            <div className="Main-content Content">
              <header className="Content-header Header">
                <h1 className="Heading Heading--primary">Debat niet gevonden</h1>
              </header>
              <br />
              <p className="Text">
                Voor een overzicht van actuele debatten gaat u naar de&nbsp;
                <InternalLink className="Link Link--underline" href={this.context.pathTo('home')}>
                  indexpagina.
                </InternalLink>
                <br />U kunt ook de&nbsp;
                <InternalLink className="Link Link--underline" href={this.context.pathTo('search')}>
                  zoekpagina
                </InternalLink>
                &nbsp;gebruiken om debatten te zoeken.
              </p>
            </div>
          </SmartScrollView>
        </div>
      </main>
    );
  };

export default component('NotFoundComponent', definition, render);
